import React, { Component } from 'react';
import './App.css';
import btn_icon_1035288 from './images/btn_icon_1035288.png';
import btn_icon_729713 from './images/btn_icon_729713.png';
import firebase from 'firebase';

export default class Favorite extends Component {

  // Properties used by this component:
  // document_key, favoritedocumentid, visualStateIndex

  constructor(props) {
    super(props);
    
    this.state = {
      fieldDrinkDocumentId: this.props.document_key || '',
      fieldFavoriteDocumentID: this.props.favoritedocumentid || '',
      fieldDrinkDocumentId: this.props.document_key || '',
      fieldFavoriteDocumentID: this.props.favoritedocumentid || '',
    };
  }

  componentDidMount() {
  }

  componentWillUnmount() {
  }

  componentDidUpdate() {
  }

  componentWillReceiveProps(nextProps) {
  }

  // --- Functions for component state index 0 (1 of 2) --- 
  
  onClick_state0_elIconButton = (ev) => {
    this.sendData_iconButton_to_userFavoritesInput();
  
  }
  
  
  textInputChanged_fieldDrinkDocumentId = (event) => {
    this.setState({fieldDrinkDocumentId: event.target.value});
  }
  
  textInputChanged_fieldFavoriteDocumentID = (event) => {
    this.setState({fieldFavoriteDocumentID: event.target.value});
  }
  
  sendData_iconButton_to_userFavoritesInput = () => {
    const dataSheet = this.props.appActions.getDataSheet('userFavoritesInput');
  
    let row = this.props.dataSheetRow || {
      "document_key": this.props.document_key,
      "favoritedocumentid": this.props.favoritedocumentid,
    };
    row = { ...row, 
      drinkID: this.state.fieldDrinkDocumentId,
      userId: (this.props.appActions.dataSlots ? this.props.appActions.dataSlots['ds_SlotFirebaseUserId'] : ''),
    };
  
    const transformData = (input) => {
        console.log("About to add this doc: "+input)
      return input;
    }
    row = transformData(row);
  
    if (this.props.dataSheetId === dataSheet.id) {
      this.props.appActions.updateInDataSheet('userFavoritesInput', row);
    } else {
      this.props.appActions.addToDataSheet('userFavoritesInput', row);
    }
  }
  
  
  renderState0() {
    const value_text = this.props.document_key;
    
    const style_state0_elText505491 = {
      color: 'rgba(0, 0, 0, 0.8500)',
      textAlign: 'left',
     };
    let transformPropValue_textCopy = (input) => {
      // This function modifies the value for property 'text'.
      // There is a variable named 'input' that provides the property value.
      //
      return "Favorite document id: " + input;
    }
    
    const value_textCopy = transformPropValue_textCopy(this.props.favoritedocumentid);
    
    const style_state0_elTextCopy419461 = {
      color: 'rgba(0, 0, 0, 0.8500)',
      textAlign: 'left',
     };
    const style_state0_elIconButton = {
      display: 'block',
      textTransform: 'uppercase',
      backgroundImage: 'url('+btn_icon_1035288+')',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '104.284%',
      backgroundPosition: '50% 0%',
      color: '(null)',
      textAlign: 'left',
      backgroundColor: 'transparent',
      cursor: 'pointer',
      pointerEvents: 'auto',
     };
    
    const value_fieldDrinkDocumentId = this.state.fieldDrinkDocumentId;
    
    const style_state0_elFieldDrinkDocumentId321312 = {
      display: 'block',
      backgroundColor: 'white',
      paddingLeft: '1rem',
      boxSizing: 'border-box', // ensures padding won't expand element's outer size
      pointerEvents: 'auto',
     };
    
    const value_fieldFavoriteDocumentID = this.state.fieldFavoriteDocumentID;
    
    const style_state0_elFieldFavoriteDocumentID308924 = {
      display: 'block',
      backgroundColor: 'white',
      paddingLeft: '1rem',
      boxSizing: 'border-box', // ensures padding won't expand element's outer size
      pointerEvents: 'auto',
     };
    
    return (
      <div className="Favorite">
        <div className="layoutFlow">
          <div className="state0_elText505491">
            <div className="baseFont" style={style_state0_elText505491}>
              <div>{value_text !== undefined ? value_text : (<span className="propValueMissing">{this.props.locStrings.favorite_text_505491}</span>)}</div>
            </div>
          </div>
          
          <div className="state0_elTextCopy419461">
            <div className="baseFont" style={style_state0_elTextCopy419461}>
              <div>{value_textCopy !== undefined ? value_textCopy : (<span className="propValueMissing">{this.props.locStrings.favorite_textcopy_419461}</span>)}</div>
            </div>
          </div>
        </div>
        
        <div className="foreground">
          <button className="actionFont state0_elIconButton" style={style_state0_elIconButton} onClick={this.onClick_state0_elIconButton}  />
          <input className="baseFont state0_elFieldDrinkDocumentId321312" style={style_state0_elFieldDrinkDocumentId321312} type="text" placeholder={this.props.locStrings.favorite_field_321312} onChange={this.textInputChanged_fieldDrinkDocumentId} value={value_fieldDrinkDocumentId !== undefined ? value_fieldDrinkDocumentId : ''}  />
          <input className="baseFont state0_elFieldFavoriteDocumentID308924" style={style_state0_elFieldFavoriteDocumentID308924} type="text" placeholder={this.props.locStrings.favorite_field2_308924} onChange={this.textInputChanged_fieldFavoriteDocumentID} value={value_fieldFavoriteDocumentID !== undefined ? value_fieldFavoriteDocumentID : ''}  />
        </div>
      </div>
    )
  }
  
  // --- Functions for component state index 1 (2 of 2) --- 
  
  onClick_state1_elIconButton = (ev) => {
    // Write your script here
    const db = firebase.firestore();
    let favoriteId=this.props.favoritedocumentid;
    if (favoriteId!=='' && favoriteId != undefined){
        let deleteDoc = db.collection('users').doc('t9IlJKa0EZUNlHhGjAhD').collection('userfavorites').doc(favoriteId);
    	console.log('deleted document: ' + deleteDoc.id);
    	deleteDoc.delete();
        }
    else{
    	console.log('No favoritedocumentid found');
    }
    
    
  
  }
  
  
  textInputChanged_fieldDrinkDocumentId = (event) => {
    this.setState({fieldDrinkDocumentId: event.target.value});
  }
  
  textInputChanged_fieldFavoriteDocumentID = (event) => {
    this.setState({fieldFavoriteDocumentID: event.target.value});
  }
  
  renderState1() {
    const value_text = this.props.document_key;
    
    const style_state1_elText505491 = {
      color: 'rgba(0, 0, 0, 0.8500)',
      textAlign: 'left',
     };
    let transformPropValue_textCopy = (input) => {
      // This function modifies the value for property 'text'.
      // There is a variable named 'input' that provides the property value.
      //
      return "Favorite document id: " + input;
    }
    
    const value_textCopy = transformPropValue_textCopy(this.props.favoritedocumentid);
    
    const style_state1_elTextCopy419461 = {
      color: 'rgba(0, 0, 0, 0.8500)',
      textAlign: 'left',
     };
    const style_state1_elIconButton = {
      display: 'block',
      textTransform: 'uppercase',
      backgroundImage: 'url('+btn_icon_729713+')',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '104.284%',
      backgroundPosition: '50% 0%',
      color: '(null)',
      textAlign: 'left',
      backgroundColor: 'transparent',
      cursor: 'pointer',
      pointerEvents: 'auto',
     };
    
    const value_fieldDrinkDocumentId = this.state.fieldDrinkDocumentId;
    
    const style_state1_elFieldDrinkDocumentId321312 = {
      display: 'block',
      backgroundColor: 'white',
      paddingLeft: '1rem',
      boxSizing: 'border-box', // ensures padding won't expand element's outer size
      pointerEvents: 'auto',
     };
    
    const value_fieldFavoriteDocumentID = this.state.fieldFavoriteDocumentID;
    
    const style_state1_elFieldFavoriteDocumentID308924 = {
      display: 'block',
      backgroundColor: 'white',
      paddingLeft: '1rem',
      boxSizing: 'border-box', // ensures padding won't expand element's outer size
      pointerEvents: 'auto',
     };
    
    return (
      <div className="Favorite">
        <div className="layoutFlow">
          <div className="state1_elText505491">
            <div className="baseFont" style={style_state1_elText505491}>
              <div>{value_text !== undefined ? value_text : (<span className="propValueMissing">{this.props.locStrings.favorite_text_505491}</span>)}</div>
            </div>
          </div>
          
          <div className="state1_elTextCopy419461">
            <div className="baseFont" style={style_state1_elTextCopy419461}>
              <div>{value_textCopy !== undefined ? value_textCopy : (<span className="propValueMissing">{this.props.locStrings.favorite_textcopy_419461}</span>)}</div>
            </div>
          </div>
        </div>
        
        <div className="foreground">
          <button className="actionFont state1_elIconButton" style={style_state1_elIconButton} onClick={this.onClick_state1_elIconButton}  />
          <input className="baseFont state1_elFieldDrinkDocumentId321312" style={style_state1_elFieldDrinkDocumentId321312} type="text" placeholder={this.props.locStrings.favorite_field_321312} onChange={this.textInputChanged_fieldDrinkDocumentId} value={value_fieldDrinkDocumentId !== undefined ? value_fieldDrinkDocumentId : ''}  />
          <input className="baseFont state1_elFieldFavoriteDocumentID308924" style={style_state1_elFieldFavoriteDocumentID308924} type="text" placeholder={this.props.locStrings.favorite_field2_308924} onChange={this.textInputChanged_fieldFavoriteDocumentID} value={value_fieldFavoriteDocumentID !== undefined ? value_fieldFavoriteDocumentID : ''}  />
        </div>
      </div>
    )
  }
  
  
  render() {
    switch (parseInt((this.state && this.state.visualStateIndexOverride !== undefined) ? this.state.visualStateIndexOverride : this.props.visualStateIndex, 10)) {
      default:
      case 0:
        return this.renderState0();
      case 1:
        return this.renderState1();
    }
  }
  
}
